﻿import { components } from '@/bundles/components';
import { initiateVueIslands } from '@uselab/vue-islands';
import Vue3TouchEvents from 'vue3-touch-events';

import '@/bundles/main.scss';

const isDevMode = import.meta.env.MODE === 'development';

initiateVueIslands(components, {
  isDevMode,
  configureApp: async (app) => {
    app.use(Vue3TouchEvents);
  }
});
